<script setup lang="ts"></script>

<template>
  <div class="app-tooltip">
    <slot></slot>
  </div>
</template>

<style scoped lang="scss">
.app-tooltip {
  position: absolute;
  left: 0;
  right: 0;
  bottom: calc(100% + 12px);
  padding: calc($base-space * 4);
  border-radius: 12px;
  background-color: var(--color-semantic-background-normal-primary);
  box-shadow: 0 12px 32px 0 rgba(33, 34, 36, 0.12);

  &:after {
    content: "";
    height: 12px;
    width: 12px;
    position: absolute;
    clip-path: polygon(0% 0%, 100% 100%, 0% 100%);
    border-radius: 0 0 0 2px;
    background-color: var(--color-semantic-background-normal-primary);
    top: calc(100% - 6px);
    left: calc(50% - 6px);
    rotate: 315deg;
  }
}
</style>
